import { useDispatch } from 'react-redux'
import { useState } from 'react'
import TableFilter from './tableFilter'
import ExportButton from '../../common/ExportButton'
import { appAllGetFacilityBooking } from '../../store/facilitybooking'
import { facilityBookingExportColumns } from '../../config/exportColumns/facilityBookingExportColumns'

function FacilityBooking() {
	const dispatch = useDispatch()

	const hubId = localStorage.getItem('hubId')
	const permissionOfHub = localStorage.getItem('permissionOfHub')

	const [exportFilters, setExportFilters] = useState({})

	return (
		<>
			<div className="content-wrapper">
				<div className="content-heading d-flex justify-content-between">
					<div>Facility Booking</div>

					<ExportButton
						fetchAction={params =>
							dispatch(
								appAllGetFacilityBooking({
									...params,
									...exportFilters,
									hub: hubId || permissionOfHub,
									limit: 10000,
									loading: false,
								}),
							)
						}
						columns={facilityBookingExportColumns}
						fileName="Facility_Bookings"
						sheetName="Facility Booking List"
						buttonText="Export Bookings"
					/>
				</div>

				<TableFilter setExportFilters={setExportFilters} />
			</div>
		</>
	)
}

export default FacilityBooking
